angular.module('cloneSettingsModule', ['ui.select'])

.service('cloneSettingsService', function($http, hostUrl) {
	return {
		cloneSettings: cloneSettings
	};
	
	function cloneSettings(source, dest, args) {
		var url = hostUrl + '2/CloneFactorySettings/src/' + source + '/dst/' + dest;
		return $http.put(url, args)
			.then(cloneSettingsComplete)
			.catch(cloneSettingsFailed);
		
		function cloneSettingsComplete(response) {
			return response;
		}
		
		function cloneSettingsFailed(error) {
			return error;
		}
	}
})

.controller('cloneSettingsCtrl', function($scope, $rootScope, $timeout, cloneSettingsService, globalConfigService) {
	$timeout(function(){
		jQuery('li.list-group-item.selected').removeClass('selected');
		jQuery('#cloneSettings').addClass('selected');
	}, 0);
	
	$scope.factoryList = [];
	$scope.source = undefined;
	$scope.dest = undefined;
	$scope.cloneProcurement = true;
	$scope.cloneSupplierPerformance = true;
	$scope.cloneLeanSync = true;
	$scope.cloneWorkbench = false;
	$scope.approver = '';
	
	$scope.clone = function() {
		if (!$scope.cloneProcurement && !$scope.cloneLeanSync && !$scope.cloneSupplierPerformance && !$scope.cloneWorkbench) {
			addErrorMessage('Please select at least one setting to clone');
			return;
		}
		if ($scope.approver.trim() === '') {
			addErrorMessage('Please enter an approver');
			return;
		}
		var args = {};
		args['procurement'] = $scope.cloneProcurement;
		args['leanSync'] = $scope.cloneLeanSync;
		args['scorecard'] = $scope.cloneSupplierPerformance;
		args['workbench'] = $scope.cloneWorkbench;
		args['approver'] = $scope.approver;
		if ($scope.source && $scope.source.id && $scope.dest && $scope.dest.id){
			cloneSettingsService.cloneSettings($scope.source.id, $scope.dest.id, args)
				.then(function(response) {
					if (response.status && response.status >= 400) {
						if (response.data && response.data.error) {
							$rootScope.$emit('toast', {'message': response.data.error, 'success': false});
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					} else if (response.status && response.status == 201) {
						$scope.approver = '';
						$rootScope.$emit('toast', {'message': 'Factory settings cloned successfully', 'success': true});
					}
				});
		}
	};
	
	globalConfigService.getAllFactoriesForUser().then(function(data) {
		$scope.factoryList = data;
		if ($scope.factoryList && $scope.factoryList.length) {
			$scope.source = $scope.factoryList[0];
			$scope.dest = $scope.factoryList[0];
		}
	});
})
;
